import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.9309 18.0522C14.2716 19.2764 12.2203 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 12.2203 19.2764 14.2716 18.0522 15.9309L23.8607 21.7394L21.7394 23.8607L15.9309 18.0522ZM17 11H11V9H17V11ZM8.70711 9.29289L5.70711 6.29289L4.29289 7.70711L6.58579 10L4.29289 12.2929L5.70711 13.7071L8.70711 10.7071C9.09763 10.3166 9.09763 9.68342 8.70711 9.29289Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }